export const styles = {
    container: {
        display: "grid",
        gridTemplateColumns: ["100px 1fr"],
        columnGap: [2, 2, 2, 4],
        pb: [3, 3, 3, 6],
        rowGap: 3,
    },
    rightPanel: {
        display: "inline-block",
        w: "100%",
        justifyContent: "space-between",
        fontSize: ["mobileBodyTextSmall", "desktopBodyTextSmall"],
    },
    metaContainer: {
        mt: 2,
    },
    price: {
        mt: 2,
    },
    offersWrapper: {
        pt: 0,
        gridColumnEnd: 3,
        gridColumnStart: 1,
    },
};
